import get from 'lodash/get';
import { LOCATION_CHANGE } from 'connected-react-router';
import { getRoute } from 'store/router/routerSelectors';
import { routeChangeHandler } from './routeChangeHandler';

export const routeHooksMiddleware = (store) => (next) => (action) => {
  if (action.type !== LOCATION_CHANGE) return next(action);

  const routeBefore = getRoute(store.getState()) || {};
  const result = next(action);
  const routeAfter = getRoute(store.getState()) || {};
  const routeAction = get(action, 'payload.action');
  const isRouteChange = routeBefore.url !== routeAfter.url;

  if (isRouteChange) {
    routeChangeHandler({ store, routeBefore, routeAfter, routeAction });
  }

  return result;
};
